import { stableTextHash } from '../../utils/stableTextHash';

const normalizeText = (value = '') => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/\([^)]*\)/g, ' ')
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const normalizeCandidateKeyPart = normalizeText;

export const buildCandidateKey = ({
  originId = '',
  domain = '',
  label = '',
  canonicalLabel = '',
  sourceAnchor = '',
} = {}) => {
  const cleanOriginId = String(originId || '').trim();
  const cleanDomain = normalizeText(domain);
  const cleanLabel = normalizeText(canonicalLabel || label);
  const cleanAnchor = normalizeText(sourceAnchor);
  const keyText = [cleanOriginId, cleanDomain, cleanLabel, cleanAnchor]
    .filter(Boolean)
    .join('|');

  return [
    'reviewable',
    cleanDomain || 'item',
    stableTextHash(keyText || 'missing'),
  ].join('_');
};
